import { useContext, useState, useEffect } from 'react';
import Link from '@/helpers/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navbar, Nav, NavDropdown, Row, Col } from 'react-bootstrap';
import { NavDropdownMenu } from 'react-bootstrap-submenu';
import { AccountContext } from '@/context/account.context';
import { DropdownSubmenu } from '@/components/DropdownSubmenu/DropdownSubmenu';
import { tagHelpers } from '@/utils/helpers';
import TopicPages from '@/utils/api/odas/topic_page';
import TagIcons from '@/utils/tags_icons.json';
import { SolutionContext } from '@/context/solution.context';

const BrowseResourcesMenu = function ({ t, classes, nestedDropDownItem }) {
  const { solution } = useContext(SolutionContext);
  const { isLoggedIn, data: accountInfo } = useContext(AccountContext);
  const [topicPages, setTopicPages] = useState([]);

  const showBrowseResourcesMenu = solution.includes?.browse_resources_menu;
  const region = accountInfo?.region;

  useEffect(() => {
    fetchTopicPages();
  }, [region]);

  const fetchTopicPages = () => {
    if (region) {
      TopicPages.fetchTopicPages(region).then((response) => {
        if (response?.data) {
          setTopicPages(response.data);
        }
      });
    }
  };

  const renderTopicPages = () => {
    if (!topicPages || topicPages.length === 0) return null;
    const items = [];
    const subItems = [];
    const displayTitle = (
      <>
        <FontAwesomeIcon icon={['fas', TagIcons['Community Pages']]} aria-hidden="true" />
        &nbsp;&nbsp; {t('Community Pages')}
        <span className="right">
          <FontAwesomeIcon icon={['fa', 'angle-right']} aria-hidden="true" />
        </span>
      </>
    );

    if (topicPages && topicPages.length && topicPages.length <= 3) {
      items.push(
        <DropdownSubmenu show={false} key={'1'} title={displayTitle}>
          {topicPages.map((tagKey, index) => (
            <NavDropdown.Item href={tagKey.slug} key={tagKey.id}>
              <span className="parent-item">{t(tagKey.title?.trim())}</span>
            </NavDropdown.Item>
          ))}
        </DropdownSubmenu>
      );
    } else {
      topicPages.map((tagKey, index) =>
        subItems.push(
          <NavDropdown.Item href={tagKey.slug} key={tagKey.id}>
            <span className="parent-item">{t(tagKey.title?.trim())}</span>
          </NavDropdown.Item>
        )
      );
      let breakPoint = Math.ceil(subItems.length / 2);
      items.push(
        <DropdownSubmenu show={false} key={'1'} title={displayTitle}>
          <Row key={'subItems'}>
            <Col className="text-wrap">{subItems.slice(0, breakPoint)}</Col>
            <Col className="text-wrap">{subItems.slice(breakPoint, subItems.length)}</Col>
          </Row>
        </DropdownSubmenu>
      );
    }

    return items;
  };

  if (!showBrowseResourcesMenu) return null;

  return (
    <div className={`${classes.menuBrowseResourceDropdown} ${classes.headerBtn} ${classes.fixedHeight}`}>
      <Navbar collapseOnSelect expand="lg" variant="">
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            <NavDropdownMenu
              title={
                <>
                  {t('Browse resources')} <FontAwesomeIcon icon={['fa', 'caret-down']} aria-hidden="true" />
                </>
              }
              id="collapsible-nav-dropdown"
              className={`${isLoggedIn ? classes.right : ''} ${classes.browseResource} ${classes.headerBtn} ${classes.fixedHeight}`}
            >
              <NavDropdown.Item as={Link} href="/browse" className={classes.browseAllCategories}>
                <FontAwesomeIcon icon={[`fa`, `th`]} aria-hidden="true" />
                &nbsp;&nbsp;{t('Browse All Categories')}
              </NavDropdown.Item>
              {nestedDropDownItem(tagHelpers.reOrderTags(tagHelpers.tags))}
              {renderTopicPages()}
            </NavDropdownMenu>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default BrowseResourcesMenu;
